<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row p-3">
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              size="large"
              v-model="model.farm_id"
              v-bind:collapse-tags="true"
              :placeholder="`${$t('common_words.select')}...`"
              class="select-primary custom-width-select required-farm shadow-sm"
              @change="getLotByFarm()"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label>{{ $t('common_words.allotment') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              size="large"
              v-model="model.lot_id"
              v-bind:collapse-tags="true"
              :placeholder="`${$t('common_words.select')}...`"
              class="select-primary custom-width-select required-lot shadow-sm"
            >
              <el-option
                v-for="(option, index) in lots"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-3">
            <label>{{ $t('common_words.date') }}: *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              type="date"
              range-separator="-"
              v-model="model.date"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="shadow-sm date-form required-date"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-xl-3">
            <br class="mb-1" />
            <button
              class="btn btn-success custom-shadow-btn btn-filter"
              @click="validateGeneralData"
            >
              {{ $t('common_words.generate') }}
            </button>
          </div>
        </div>
      </card>
      <div v-if="haveData">
        <card
          class="custom-shadow-card-header mt-4"
          :title="$t('sigatoka.biological_warning')"
        >
          <div class="mt-4 px-3">
            <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
              <div
                class="table-responsive custom-scroll-table-wrapper mb-5 border"
              >
                <table
                  class="table table-striped table-bordered not-last-td table-data m-0"
                >
                  <thead>
                    <tr class="cusmtom-thead-color">
                      <th
                        scope="col"
                        rowspan="3"
                        class="text-center p-2 m-0 custom-header-label sticky-header-1"
                        style="width: 200px"
                      >
                        <strong>{{ $t('sigatoka.plant') }}*</strong>
                      </th>
                      <th
                        scope="col"
                        rowspan="3"
                        class="text-center p-2 m-0 custom-header-label sticky-header-1"
                        style="width: 200px"
                      >
                        <strong>{{ $t('sigatoka.last_week') }}*</strong>
                      </th>
                      <th
                        scope="col"
                        rowspan="3"
                        class="text-center p-2 m-0 custom-header-label sticky-header-1"
                        style="width: 200px"
                      >
                        <strong>{{ $t('sigatoka.actual_week') }}*</strong>
                      </th>
                      <th
                        v-for="(leaf, index) in model.leafs"
                        :key="'leaf.' + index"
                        scope="col"
                        :colspan="leaf.plus.length"
                        class="text-center p-2 m-0 custom-header-label sticky-header-1"
                      >
                        <strong
                          >{{ $t('sigatoka.leaf') }} {{ leaf.number }}</strong
                        >
                      </th>
                      <th
                        scope="col"
                        rowspan="3"
                        class="text-center p-2 m-0 custom-header-label sticky-col-2"
                        style="min-width: 90px"
                      >
                        <strong>{{ $t('common_words.options') }}</strong>
                      </th>
                    </tr>
                    <tr class="cusmtom-thead-color">
                      <template v-for="(leaf, index) in model.leafs">
                        <th
                          v-for="(status, i) in leaf.status"
                          :key="'leaf.' + index + '.status.' + i"
                          class="text-center p-2 m-0 custom-header-label sticky-header-2"
                        >
                          {{ status }}
                        </th>
                      </template>
                    </tr>
                    <tr class="cusmtom-thead-color">
                      <template v-for="(leaf, index) in model.leafs">
                        <th
                          v-for="(plus, i) in leaf.plus"
                          :key="'leaf.' + index + '.gross.' + i"
                          class="text-center p-3 custom-header-label sticky-header-3"
                        >
                          {{ leaf.minus[i] }}/ {{ plus }}
                        </th>
                      </template>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(_, index) in model.plants_count"
                      :key="'plant.' + index"
                    >
                      <td>
                        <fg-input
                          type="number"
                          :value="index + 1"
                          class="m-0 p-0"
                          disabled
                        ></fg-input>
                      </td>
                      <td>
                        <fg-input
                          type="number"
                          placeholder="..."
                          @keypress="validateInput"
                          v-model="model.last_week[index]"
                          :class="`m-0 p-0 required-lw-${index}`"
                        ></fg-input>
                      </td>
                      <td>
                        <fg-input
                          type="number"
                          placeholder="..."
                          @keypress="validateInput"
                          v-model="model.actual_week[index]"
                          :class="`m-0 p-0 required-aw-${index}`"
                        ></fg-input>
                      </td>
                      <template v-for="(leaf, leafIndex) in model.leafs">
                        <td
                          v-for="number in leaf.status.length"
                          :key="
                            'plant.' +
                            index +
                            '.leaf.' +
                            leafIndex +
                            '.status.' +
                            number
                          "
                        >
                          <div class="d-flex justify-content-center">
                            <a
                              class="btn-simple btn-link custom-margin-actions btn-lg"
                              :class="getButtonClass(leafIndex, index, number)"
                              @click="
                                handleChange(leafIndex, index, number - 1)
                              "
                            >
                              <em
                                class="custom-size-fa-actions"
                                :class="getIconClass(leafIndex, index, number)"
                              ></em>
                            </a>
                          </div>
                        </td>
                      </template>
                      <td
                        class="text-center sticky-col"
                        style="min-width: 90px"
                      >
                        <div class="d-flex justify-content-center mt-3">
                          <a
                            v-if="isUpdate() && index + 1 == model.plants_count"
                            v-tooltip.top-center="$t('common_words.add')"
                            class="btn-warning btn-simple btn-link custom-margin-actions"
                            @click="handleAdd"
                          >
                            <em class="fa fa-plus custom-size-fa-actions"></em>
                          </a>
                          <a
                            v-if="model.plants_count > 1"
                            v-tooltip.top-center="$t('common_words.erase')"
                            class="btn-danger btn-simple btn-link custom-margin-actions"
                            @click="handleMinus(index)"
                          >
                            <em class="fa fa-times custom-size-fa-actions"></em>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="w-100 mb-5 d-flex justify-content-around">
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.total_last_week') }}:</strong>
                  </h6>
                  {{ lastWeekTotal }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.total_actual_week') }}:</strong>
                  </h6>
                  {{ actualWeekTotal }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.ref') }}:</strong>
                  </h6>
                  {{ ref }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.reh') }}1:</strong>
                  </h6>
                  {{ reh1 }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.reh') }}:</strong>
                  </h6>
                  {{ reh }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.rem') }}:</strong>
                  </h6>
                  {{ rem }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.gross_sum') }}:</strong>
                  </h6>
                  {{ gross_sum }}
                </div>
                <div>
                  <h6>
                    <strong>{{ $t('sigatoka.evolutionary_status') }}:</strong>
                  </h6>
                  {{ evolutionaryStage }}
                </div>
              </div>
              <div
                class="row w-100 d-flex justify-content-center align-items-center"
              >
                <div
                  :class="`col-6 pr-0 ${
                    model.id != null ? 'text-right' : 'text-center'
                  }`"
                  v-if="isCreate() || isUpdate()"
                >
                  <button
                    class="btn btn-success custom-shadow-btn btn-filter m-4"
                    @click="validateRequest()"
                  >
                    {{ $t('common_words.save') }}
                  </button>
                </div>
                <div
                  class="col-6 pl-0 text-left"
                  v-if="isDelete() && model.id != null"
                >
                  <button
                    class="btn btn-danger custom-shadow-btn btn-filter m-4"
                    @click="handleDelete()"
                  >
                    {{ $t('common_words.delete') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import { isset } from 'src/util/Util';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import Filter from 'src/components/Filter/Filters.vue';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  mixins: [MixinLoading, MixinMasters, MixinPermissions, MixinForm, MixinMenu],
  components: {
    [Filter.name]: Filter,
  },
  data() {
    return {
      lots: [],
      farms: [],
      hasBw: false,
      haveData: false,
      haveLastCapture: false,
      model: {
        id: null,
        week_values_id: null,
        gs: 0,
        es: 0,
        ref: 0,
        reh: 0,
        rem: 0,
        reh1: 0,
        date: null,
        total_aw: 0,
        total_lw: 0,
        lot_id: null,
        farm_id: null,
        last_week: [],
        actual_week: [],
        plants_count: 10,
        sigatoka_config_bw_id: null,
        leafs: [
          {
            id: null,
            number: 3,
            minus: [40, 80, 120],
            plus: [60, 100, 140],
            status: [1, 2, 3],
            calification: [],
            value: [],
            gross_sum: [],
            califications_ids: [],
            gross_sum_ids: [],
          },
          {
            id: null,
            number: 4,
            minus: [20, 60, 100],
            plus: [40, 80, 120],
            status: [1, 2, 3],
            calification: [],
            value: [],
            gross_sum: [],
            califications_ids: [],
            gross_sum_ids: [],
          },
          {
            id: null,
            number: 5,
            minus: [10, 40, 80, 120],
            plus: [20, 60, 100, 140],
            status: [1, 2, 3, 4],
            calification: [],
            value: [],
            gross_sum: [],
            califications_ids: [],
            gross_sum_ids: [],
          },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    getRoute() {
      return 'sigatoka/biologicalwarning';
    },
    lastWeekTotal() {
      this.model.total_lw = 0;
      this.model.last_week.map((v) => (this.model.total_lw += Number(v)));

      return Math.round(this.model.total_lw * 100) / 100;
    },
    actualWeekTotal() {
      this.model.total_aw = 0;
      this.model.actual_week.map((v) => (this.model.total_aw += Number(v)));

      return Math.round(this.model.total_aw * 100) / 100;
    },
    ref() {
      this.model.ref = 0;
      this.model.ref =
        (this.actualWeekTotal - this.lastWeekTotal) / this.model.plants_count;

      return Math.round(this.model.ref * 100) / 100;
    },
    reh1() {
      this.model.reh1 = 0;
      this.model.reh1 = (this.actualWeekTotal - this.lastWeekTotal) / 7;

      return Math.round(this.model.reh1 * 100) / 100;
    },
    reh() {
      if (!this.haveLastCapture) return Math.round(this.model.reh1 * 100) / 100;

      return this.model.reh;
    },
    rem() {
      this.model.rem = 0;
      this.model.rem = (this.reh1 + this.reh) / 2;

      return Math.round(this.model.rem * 100) / 100;
    },
    gross_sum() {
      this.model.gs = 0;
      this.model.leafs.forEach((leaf) => {
        leaf.calification.forEach((object) => {
          object.forEach((value) => {
            this.model.gs += value;
          });
        });
      });
      this.model.leafs.forEach((leaf) => {
        leaf.gross_sum = new Array(leaf.status.length).fill(0);
      });
      this.model.leafs.forEach((leaf) => {
        leaf.calification.forEach((object) => {
          object.forEach((value, valIndex) => {
            if (!leaf.gross_sum[valIndex]) {
              leaf.gross_sum[valIndex] = 0;
            }
            leaf.gross_sum[valIndex] += value;
          });
        });
      });

      return this.model.gs;
    },
    evolutionaryStage() {
      this.model.es = 0;
      this.model.es = (this.rem * this.gross_sum) / this.model.leafs.length;

      return Math.round(this.model.es * 100) / 100;
    },
  },
  methods: {
    handleAdd() {
      this.model.plants_count++;
      this.model.leafs.forEach((leaf) => {
        const cols = leaf.status.length;
        leaf.value.push(Array(cols).fill(0));
        leaf.calification.push(Array(cols).fill(0));
        leaf.califications_ids.push(Array(cols).fill(null));
      });
    },
    handleMinus(index) {
      if (this.model.plants_count > 1) {
        this.model.plants_count--;
        this.model.last_week.splice(index, 1);
        this.model.actual_week.splice(index, 1);
        this.model.leafs.forEach((leaf) => {
          leaf.value.splice(index, 1);
          leaf.calification.splice(index, 1);
          leaf.califications_ids.splice(index, 1);
        });
      }
    },
    handleChange(leafIndex, index, number) {
      const current = this.model.leafs[leafIndex].value[index][number];
      let next = 0;
      if (current == 0) next = 'minus';
      else if (current === 'minus') next = 'plus';
      else if (current === 'plus') next = 0;
      this.$set(this.model.leafs[leafIndex].value[index], number, next);
      this.handleGrossSum(leafIndex, index, number);
    },
    handleGrossSum(leafIndex, index, number) {
      let calification = 0;
      const value = this.model.leafs[leafIndex].value[index][number];
      const minus = this.model.leafs[leafIndex].minus[number];
      const plus = this.model.leafs[leafIndex].plus[number];
      if (value == 0) calification = 0;
      if (value == 'minus') calification = minus;
      if (value == 'plus') calification = plus;
      this.$set(
        this.model.leafs[leafIndex].calification[index],
        number,
        calification
      );
    },
    handleDelete() {
      if (!isset(this.model.id)) return;
      this.model.route = this.getRoute;
      SweetAlert.delete(
        i18n.t('common_words.confirm'),
        i18n.t('sigatoka.confirm_capture_delete')
      ).then((result) => {
        if (result) {
          this.showHideLoading(true);
          Axios.destroyMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() =>
                this.cleanData()
              );
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        }
      });
      this.showHideLoading();
    },
    setBwConfig(data) {
      this.model.leafs = [];
      this.model.sigatoka_config_bw_id = data.sigatoka_config_bws[0].id;
      data.sigatoka_config_bws.forEach((object, index) => {
        this.model.leafs.push({
          id: null,
          number: object.leaf,
          minus: [],
          plus: [],
          status: [],
          calification: [],
          value: [],
          gross_sum: [],
          califications_ids: [],
          gross_sum_ids: [],
        });
        object.sigatoka_config_bw_grosses.forEach((obj) => {
          this.model.leafs[index].minus.push(obj.minus);
          this.model.leafs[index].plus.push(obj.plus);
        });
        object.sigatoka_config_bw_statuses.forEach((obj) =>
          this.model.leafs[index].status.push(obj.status)
        );
      });
      this.setArrays();
    },
    setArrays() {
      this.model.leafs = this.model.leafs.map((leaf) => {
        const cols = leaf.status.length;
        const rows = this.model.plants_count;

        return {
          ...leaf,
          value: this.createMatrix(rows, cols, 0),
          calification: this.createMatrix(rows, cols, 0),
          califications_ids: this.createMatrix(rows, cols, null),
        };
      });
    },
    createMatrix(rows, cols, fillValue) {
      return Array.from({ length: rows }, () => Array(cols).fill(fillValue));
    },
    hasBwConfig(data) {
      this.hasBw = data.config_bio_warning == 0 ? false : true;
      if (this.hasBw == true) this.setBwConfig(data);
    },
    async hasConfig() {
      this.showHideLoading(true);
      this.model.route = this.getRoute + '/config';
      const configRes = await Axios.getMasters(this.model.route);
      if (!configRes || !configRes.data.data) return false;
      const config = configRes.data.data;
      this.hasBwConfig(config);
      await this.getBiologicalWarning();
      this.haveData = true;
      this.showHideLoading();

      return true;
    },
    async getBiologicalWarning() {
      this.model.route = this.getRoute + '/getbiowarning';
      const response = await Axios.postMasters(this.model);
      const data = response.data.data;
      await this.getLastCapture(data);
      if (!data.header) return false;
      const bio = data.header;
      const bwLeaves = bio.sigatoka_bw_leaves;
      const bwWeek = bio.sigatoka_bw_week_values;
      this.model.id = bio.id;
      this.model.week_values_id = bwWeek.map((v) => v.id);
      this.model.last_week = bwWeek.map((v) => v.last_week);
      this.model.actual_week = bwWeek.map((v) => v.actual_week);
      this.model.plants_count = this.model.actual_week.length;
      bwLeaves.forEach((leaf, leafIndex) => {
        const modelLeaf = this.model.leafs[leafIndex];
        modelLeaf.id = leaf.id;
        const califications = leaf.sigatoka_bw_califications;
        const grossSums = leaf.sigatoka_bw_gross_sums;
        const statusLen = modelLeaf.status.length;
        const plants = this.model.plants_count;
        const buildMatrix = (key) =>
          Array.from({ length: plants }, (_, i) =>
            Array.from({ length: statusLen }, (_, j) => {
              const index = i * statusLen + j;
              return califications[index][key] || 0;
            })
          );
        modelLeaf.value = buildMatrix('value');
        modelLeaf.calification = buildMatrix('calification');
        modelLeaf.califications_ids = buildMatrix('id');
        modelLeaf.gross_sum_ids = grossSums.map((v) => v.id);
      });
    },
    getLastCapture(data) {
      const lastHeader = data.lastHeader;
      if (!lastHeader.reh1 || lastHeader.actual_weeks.length == 0) return;
      this.model.reh = lastHeader.reh1;
      for (let i = 0; i < this.model.plants_count; i++)
        this.model.last_week[i] = lastHeader.actual_weeks[i];
      this.haveLastCapture = true;
    },
    getValue(leafIndex, index, number) {
      return this.model.leafs[leafIndex].value[index][number - 1];
    },
    getButtonClass(leafIndex, index, number) {
      const value = this.getValue(leafIndex, index, number);

      return {
        'btn-primary': value == 0 || value == null,
        'btn-warning': value === 'minus',
        'btn-success': value === 'plus',
      };
    },
    getIconClass(leafIndex, index, number) {
      const value = this.getValue(leafIndex, index, number);

      return {
        'fa fa-circle': value == 0 || value == null,
        'fa fa-minus': value === 'minus',
        'fa fa-plus': value === 'plus',
      };
    },
    getLotByFarm() {
      if (!isset(this.model.farm_id)) return (this.lots = []);
      this.lots = [];
      this.model.lot_id = null;
      this.farms.forEach((element) => {
        if (this.model.farm_id == element.id)
          element.lots.forEach((item) => this.lots.push(item));
      });
    },
    validateGeneralData() {
      if (!isset(this.model.farm_id))
        return this.validationInputsRequired(`farm`);
      if (!isset(this.model.lot_id))
        return this.validationInputsRequired(`lot`);
      if (!isset(this.model.date)) return this.validationInputsRequired(`date`);
      this.cleanData(true);
      this.hasConfig();
    },
    validateRequest() {
      for (let i = 0; i < this.model.plants_count; i++) {
        if (!isset(this.model.last_week[i]))
          return this.validationInputsRequired(`lw-${i}`);
        if (!isset(this.model.actual_week[i]))
          return this.validationInputsRequired(`aw-${i}`);
      }
      this.storeUpdateBw();
    },
    validateInput(event) {
      const input = String.fromCharCode(event.which);
      if (!/[0-9,.]/.test(input)) event.preventDefault();
    },
    cleanData(isGenerate) {
      if (!isGenerate) {
        this.model.farm_id = null;
        this.model.lot_id = null;
        this.model.date = null;
      }
      this.hasBw = false;
      this.model.reh = 0;
      this.model.reh1 = 0;
      this.model.id = null;
      this.haveData = false;
      this.model.last_week = [];
      this.model.actual_week = [];
      this.haveLastCapture = false;
      this.model.plants_count = 10;
      this.model.week_values_id = null;
      this.model.sigatoka_config_bw_id = null;
      this.model.leafs = [
        {
          id: null,
          number: 3,
          minus: [40, 80, 120],
          plus: [60, 100, 140],
          status: [1, 2, 3],
          calification: [],
          value: [],
          gross_sum: [],
          califications_ids: [],
          gross_sum_ids: [],
        },
        {
          id: null,
          number: 4,
          minus: [20, 60, 100],
          plus: [40, 80, 120],
          status: [1, 2, 3],
          calification: [],
          value: [],
          gross_sum: [],
          califications_ids: [],
          gross_sum_ids: [],
        },
        {
          id: null,
          number: 5,
          minus: [10, 40, 80, 120],
          plus: [20, 60, 100, 140],
          status: [1, 2, 3, 4],
          calification: [],
          value: [],
          gross_sum: [],
          califications_ids: [],
          gross_sum_ids: [],
        },
      ];
      this.setArrays();
    },
    async storeUpdateBw() {
      this.showHideLoading(true);
      if (this.isCreate() || this.isUpdate()) {
        this.model.route = this.getRoute;
        if (isset(this.model.id)) {
          await Axios.updateMaster(this.model)
            .then((response) => {
              SweetAlert.success(response.data.message).then(this.cleanData());
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
          this.showHideLoading();
        } else {
          await Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(this.cleanData());
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
          this.showHideLoading();
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },
  },
  async created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      await Axios.getMasters('farms/farms/only')
        .then((responseFarm) => {
          this.farms = responseFarm.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
      this.setArrays();
    } else {
      this.showHideLoading();
    }
  },
};
</script>
<style scoped>
.custom-scroll-table-wrapper {
  max-height: 600px;
  overflow: auto;
}
.custom-scroll-table-wrapper table {
  min-width: 1200px;
  border-collapse: collapse;
  overflow: auto;
}

.sticky-header-1 {
  position: sticky;
  top: 0;
  z-index: 3;
  background: #898989;
}

.sticky-header-2 {
  position: sticky;
  top: 37px;
  z-index: 3;
  background: #898989;
}

.sticky-header-3 {
  position: sticky;
  top: 74px;
  z-index: 3;
  background: #898989;
}

.table-data th,
.table-data td {
  white-space: nowrap;
}

.sticky-col-2 {
  position: sticky;
  background: #898989;
  z-index: 5;
  top: 0;
  right: 0;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
}

.sticky-col {
  position: sticky;
  background: #ffffff;
  z-index: 4;
  right: 0;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
}
</style>
